import React from 'react';
import TextCheckBox from 'components/shared/TextCheckBox';

import CardTextIcon from 'icons/CardTextIcon';
import TranslateIcon from 'icons/TranslateIcon';
import CheckBoxRadio from 'components/shared/CheckBoxRadio';
import { animationUrl } from 'config/endpoints';
import { getTextColor } from 'helpers/TextColorHelper';
import { DownloadOneTextWordType } from 'components/shared/DownloadFile/DownloadTextWordType';

const TextItem = ({
  text,
  idx,
  currentPage,
  textsPerPage,
  user,
  order,
  selectedTextsForValidation,
  handleClientTextValidation,
  selectedTextsForRevision,
  setSelectedTextsForRevision,
  isTextEligibleForValidation,
  isTextEligibleForRevision,
  getPath,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  setIsInfo,
  setErrorSuccess,
  hasEligibleTexts,
  availableRevisionNumber,
  t,
}) => {
  const handleTextClick = () => {
    if (!text.delivered) {
      setErrorSuccessMsg(t('Texte en cours de rédaction !'));
      setErrorSuccessImg(
        `${animationUrl}/03_Commande_en_cours_de_rédaction.gif`
      );
      setIsSuccess(true);
      setIsInfo(true);
      setErrorSuccess(true);
    } else {
      getPath(order.id, text.id, text.writerCommandId, text.type);
    }
  };

  const isEligibleForValidation = isTextEligibleForValidation(text);
  const isEligibleForRevision = isTextEligibleForRevision(text, order.type);

  return (
    <div key={text.index} className="box-list-n">
      {/* Validation Checkbox or Placeholder */}
      <div className="checkbox validation">
        {hasEligibleTexts && isEligibleForValidation ? (
          <CheckBoxRadio
            checked={selectedTextsForValidation.includes(text.id)}
            onCheck={() => handleClientTextValidation(text.id, text.textTitle)}
          />
        ) : (
          <div className="placeholder" />
        )}
      </div>

      {/* Revision Checkbox or Placeholder */}
      <div className="checkbox revision">
        {hasEligibleTexts && isEligibleForRevision ? (
          <TextCheckBox
            orderType={order.type}
            text={text}
            selectionHandlers={{
              selectedTextsForRevision,
              setSelectedTextsForRevision,
            }}
            eligibility={{
              isEligibleForRevision,
              availableRevisionNumber,
            }}
          />
        ) : (
          <div className="placeholder" />
        )}
      </div>

      {/* Text Title */}
      <div className="text-content" onClick={handleTextClick}>
        <span className={getTextColor(text)}>
          {`${(currentPage - 1) * textsPerPage + idx + 1}. `}
          {(text.type === 'NON_TRANSLATED' || text.type === 'COMBINED') && (
            <CardTextIcon />
          )}
          {text.type === 'COMBINED' && ' + '}
          {(text.type === 'TRANSLATED' || text.type === 'COMBINED') && 
           (order?.textType === 'TRANSLATION' || order?.textType === 'EDITORIAL_AND_TRANSLATION') && (
            <TranslateIcon />
          )}
          {'  '}
          {text.keyword}
        </span>
      </div>

      {/* Download */}
      <div className="download-container">
        <span
          className="bt-download-circle"
          onClick={() => DownloadOneTextWordType(text.id, user)}
        />
      </div>
    </div>
  );
};

export const TextList = ({
  currentTexts,
  isTextEligibleForValidation,
  isTextEligibleForRevision,
  ...props
}) => {
  // Determine if any text on this page is eligible for checkboxes
  const hasEligibleTexts = currentTexts.some(
    (text) =>
      isTextEligibleForValidation(text) ||
      isTextEligibleForRevision(text, props.order?.type)
  );

  return (
    <div className="box-wrap-sm">
      <div className="box-list-li">
        {currentTexts.map((text, idx) => (
          <TextItem
            key={text.index}
            text={text}
            idx={idx}
            isTextEligibleForValidation={isTextEligibleForValidation}
            isTextEligibleForRevision={isTextEligibleForRevision}
            hasEligibleTexts={hasEligibleTexts}
            {...props}
          />
        ))}
      </div>
    </div>
  );
};
